// -----------------------------------------------------------------------------
// Scripts for search overlay
// -----------------------------------------------------------------------------

$(function () {
  $('.header__search-btn').on('click',function () {
    $('.search-overlay #searchformInput').val('');
    $('.search-overlay').fadeIn(300);
    $('.search-overlay').addClass('search-overlay--open');

    setTimeout(function() {
      $('body').addClass('no-scroll');
    }, 450);
  });

  $('.search-overlay__close').on('click', function () {
    $('.search-overlay').removeClass('search-overlay--open');

    setTimeout(function() {
      $('.search-overlay').fadeOut(300);
      $('body').removeClass('no-scroll');
    }, 450);
  });
});